import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-mobile-alt mr-0" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "d-none d-lg-inline ml-1"
}

import { PhoneModule } from "@/store/modules/Phone";
//Props

export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    size: null,
    hideLabel: { type: Boolean },
    pinToBottom: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	type?:
		| "default"
		| "primary"
		| "secondary"
		| "info"
		| "success"
		| "danger"
		| "warning";
	size?: "lg" | "sm";
	hideLabel?: boolean;
	pinToBottom?: boolean;
}


const excPin = () => {
	PhoneModule.setPinKey(PhoneModule.getPinKey + 1);
};

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, { content: "Anclar teléfono" }, {
    default: _withCtx(() => [
      _createVNode(_component_base_button, {
        size: props.size ?? 'sm',
        type: props.type ?? 'secondary',
        onClickCapture: excPin,
        class: _normalizeClass(__props.pinToBottom ? 'pinToBottom' : ''),
        rounded: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (!__props.hideLabel)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Phone"))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["size", "type", "class"])
    ]),
    _: 1
  }))
}
}

})